import { useAuth } from '@/contexts/AuthContext'
import { supabase } from '@/lib/supabase'
import { recordLinkFollow } from '@/lib/usageEvents'

interface LinkCardProps {
  link: {
    id: string
    name: string
    url: string
    description: string | null
    created_by: string
    profiles?: {
      display_name: string
    } | null
  }
}

function handleLinkClick(
  e: React.MouseEvent<HTMLAnchorElement>,
  url: string,
  linkId: string,
  userId: string | null
) {
  e.preventDefault()
  recordLinkFollow(supabase, linkId, userId).then(() => {
    window.open(url, '_blank', 'noopener,noreferrer')
  })
}

export default function LinkCard({ link }: LinkCardProps) {
  const { user } = useAuth()
  const authorName = link.profiles?.display_name || 'Unknown'

  return (
    <div
      className="p-4 rounded border-2"
      style={{
        backgroundColor: 'var(--bg-secondary)',
        borderColor: 'var(--bg-tertiary)',
      }}
    >
      <a
        href={link.url}
        target="_blank"
        rel="noopener noreferrer"
        className="text-lg font-semibold mb-2 block underline"
        style={{ color: 'var(--text-primary)' }}
        onClick={(e) => handleLinkClick(e, link.url, link.id, user?.id ?? null)}
      >
        {link.name}
      </a>
      
      {link.description && (
        <p 
          className="mb-2"
          style={{ color: 'var(--text-primary)' }}
        >
          {link.description}
        </p>
      )}
      
      <a
        href={link.url}
        target="_blank"
        rel="noopener noreferrer"
        className="text-sm block mb-2 break-all underline"
        style={{ color: 'var(--text-link)' }}
        onClick={(e) => handleLinkClick(e, link.url, link.id, user?.id ?? null)}
      >
        {link.url}
      </a>
      
      <p 
        className="text-sm"
        style={{ color: 'var(--text-primary)' }}
      >
        by {authorName}
      </p>
    </div>
  )
}

